import { MenuItem } from 'interfaces'

export type TypeComponentsItemsArray =
	| 'link'
	| 'mail'
	| 'simple_text'
	| 'location'
	| 'tags'
	| 'phone'
	| 'title'
	| 'assets'
	| 'documents'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const optionsComponents: Record<TypeComponentsItemsArray, any> = {
	link: {
		component_order: 0,
		component_type: 'link',
		component_value: {
			links: [
				{
					text_link: '',
					url: ''
				}
			]
		}
	},
	mail: {
		component_order: 0,
		component_type: 'mail',
		component_value: {
			mails: [
				{
					title: '',
					email: ''
				}
			]
		}
	},
	simple_text: {
		component_order: 0,
		component_type: 'simple_text',
		component_value: {
			title: '',
			description: ''
		}
	},
	location: {
		component_order: 0,
		component_type: 'location',
		component_value: {
			title: '',
			address_line: '',
			zip_code: ''
		}
	},
	tags: {
		component_order: 0,
		component_type: 'tags',
		component_value: {
			tags: ['']
		}
	},
	phone: {
		component_order: 0,
		component_type: 'phone',
		component_value: {
			phones: [
				{
					title: '',
					phone_number: '',
					code: ''
				}
			]
		}
	},
	title: {
		component_order: 0,
		component_type: 'title',
		component_value: {
			title: ''
		}
	},
	assets: {
		component_order: 0,
		component_type: 'assets',
		component_value: {
			video: '',
			assets: []
		}
	},
	documents: {
		component_order: 0,
		component_type: 'documents',
		component_value: {
			title_section: 'Section',
			documents: []
		}
	}
}

export const getInitialStateSubMenu = {
	name: `Sub Menu Title`,
	section_order: 0,
	setup_card: {
		link: {
			enabled_link: false,
			url: ''
		}
	},
	components: []
}

export const initialStateModal = {
	open: false,
	title: '',
	description: '',
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	onConfirm: () => {}
}

export const initialStateMenu: MenuItem = {
	name: `Menu Title`,
	section_order: 0,
	setup_card: {
		link: {
			enabled_link: false,
			url: ''
		},
		menu: {
			enabled_menu: false
		}
	},
	components: [],
	sub_menus: []
}

export const sortByOrder = <T extends { section_order?: number }>(
	items: T[] = []
): T[] => {
	return [...items].sort(
		(a, b) => (a.section_order ?? 0) - (b.section_order ?? 0)
	)
}

export const sortComponents = <T extends { component_order?: number }>(
	items: T[] = []
): T[] => {
	return [...items].sort(
		(a, b) => (a.component_order ?? 0) - (b.component_order ?? 0)
	)
}

export const sortMenu = (menu: MenuItem): MenuItem => ({
	...menu,
	components: sortComponents(menu.components),
	sub_menus: menu.sub_menus
		? sortByOrder(menu.sub_menus.map(sortMenu))
		: undefined
})
